/**
 * @description
 * @author CHOISEONHA
 * @date 2024/04/08
 * @param {*}
 * @return
 */


export const energyOptions = [
  { label: "압축공기", value: "AIR" },
  { label: "스팀", value: "STEAM" }
];


export const methodOptions = [
  { label: "공급", value: "prod" },
  { label: "사용", value: "cons" }
];

export const intervalOptions = [
  { label: "실시간", value: "realtime" },
  { label: "1일", value: "day" }
];

export const predictorVariable = [
  { label: "전일 조업시간", value: "prevDayHours" },
  { label: "전일 생산량(무게)", value: "prevDayWeight" },
  { label: "전일 생산량(개수)", value: "prevDayCount" },
  { label: "전력사용량", value: "electricityUsage" },
  { label: "외기온도", value: "ambientTemp" },
  { label: "외기습도", value: "ambientHumidity" },
];


export const variableOptions = [
  { label: "압공유량", value: "compressedAirFlow" },
  { label: "스팀유량", value: "steamFlow" },
  { label: "전력사용량", value: "electricityUsage" },
  { label: "제품생산량", value: "productOutput" }
];

export const dataTypeOptions = [
  { label: "고부하", value: "highLoad" },
  { label: "저부하", value: "lowLoad" },
  { label: "지정일 가이던스 결과", value: "fixDate" },
  { label: "임의값 입력", value: "none" }
];